<template>
	<div>
		<div class="columns">
			<div class="column is-7">
				<div class="custome-header-search">
					<div class="search-field  field has-addons has-border-primary radius-md overflow-hidden">
						<div class="control is-expanded">
							<input v-model="search_input" class="input input-transparent has-text-primary rounded-input is-size-7" type="text"
							:placeholder="this.sitelocale == 'en' ? 'search' : 'بحث'">
						</div>
						<div class="control">
							<span class="select is-grey is-size-7">
								<select v-model="category_id" name="select_category">
									<option selected value="all">{{ this.CategoriesLabel }}</option>
									<option v-for="category in categories" :value="category.id">
										{{ category.name }}
									</option>
								</select>
							</span>
						</div>
						<div class="control">
							<a class="button has-right-border has-text-white has-background-primary" @click.prevent="submit()">
								<i class="fas fa-search"></i>
							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="column is-5-desktop mt60-tablet is-5-tablet is-12-mobile">
				<div class="control is-expanded has-text-left">
					<div class="select is-fullwidth-mobile is-rounded is-primary is-size-6">
						<select v-model="orderBy" name="category_filter">
							<option selected value="created_at">{{ t('last_added') }}</option>
							<option value="price_asc">{{ t('low_price') }}</option>
							<option value="price_desc">{{ t('high_price') }}</option>
							<option value="order_no">{{ t('order_no') }}</option>
						</select>
					</div>
				</div>
			</div>
		</div>
		<div v-infinite-scroll="loadNextPage" infinite-scroll-disabled="busy" infinite-scroll-distance="12">
			<div v-for="product in products" class="p20 mt20 has-text-weight-bold card">
				<div class="columns">
					<div class="column is-2">
						<a :href="product.show_url">
							<figure class="image image-contain-height height-100 has-background-white radius-lg overflow-hidden">
								<lazy-load
								src="/front/img/spinner.svg"
								:lazy-src="product.image ? product.image : '/front/img/product.png'"
                                :lazy-srcset="product.image ? product.image : '/front/img/product.png'"
								background-color="transparent"
								alt="banner"
								/>
							</figure>
						</a>
					</div>
					<div class="column is-8">
						<a :href="product.show_url" class="has-text-primary has-text-weight-bold is-block mb20">{{ product.name }}</a>
						<span v-if="product.discount != 0" class="has-text-grey has-text-weight-bold ml20 line-through">{{ product.price +' '+ t('currency') }}</span>
                        <span class="has-text-warning has-text-weight-bold">{{ product.final_price +' '+ t('currency') }}</span>
					</div>
					<div class="column is-2">
						<star-rating v-bind:increment=".5"
						:read-only="true"
						:rating="product.rate"
						v-bind:max-rating="5"
						inactive-color="#ffffff"
						border-color="#f9ca2f"
						:border-width="2"
						active-color="#f9ca2f"
						v-bind:star-size="20" :rtl="sitelocale == 'ar' ? true : false">
					</star-rating>
					<div v-if="product.discount != 0" class="mt20 has-text-centered discount radius-full has-background-warning has-text-white has-text-weight-bold">{{ product.discount }}%</div>
				</div>
			</div>
			</div>
		<div class="has-text-centered mt20" v-if="loadMore">
			<a class="button is-primary hvr-shutter-out-vertical hvr-warning is-rounded p25 pr40 pl40" href="#">{{ t('load_more')}}</a>
		</div>
	</div>
</div>
</template>

<script>
import axios from 'axios';
import infiniteScroll from 'vue-infinite-scroll';
import trans from '../SiteComponents/translation/categories.json';
export default {
	name: "SearchPage",
	directives: {
		infiniteScroll
	},
	props: {
        url: String,
		categories: {
			type: Array,
			default: () => []
		},
		CategoriesLabel:{
			type:String,
			required: true
		},
		sitelocale:{
			type:String,
			required: true
		},
        searchValue:{
            type:String,
            required: false
        },
        categoryValue:{
            type:String,
            required: false
        }
	},
	data() {
		return {
            products: [],
			category_id:'all',
			search_input:'',
			orderBy: 'created_at',
			filter: 'created_at',
			currentPage: 0,
			fetching: false,
			nextUrl : String,
			loadMore : true,
		};
	},
	computed: {
		busy() {
			return this.fetching
		}
	},
	mounted() {
		this.$translate.setLang(this.sitelocale);
		this.search_input = this.searchValue
        this.category_id = this.categoryValue
	},
	locales: trans,
	methods: {
        loadNextPage() {
            this.currentPage++;
            this.fetching = true;
            if(this.nextUrl != null){
                axios.get(this.nextUrl).then(({ data }) => {
                    this.products.push(...data.data);
                    if(data.links.next != null) {
                        this.nextUrl = data.links.next;
                    } else {
                        this.nextUrl = data.links.next;
                    }
                    this.fetching = false;
                });
            }
            else{
                this.loadMore = false;
            }
        },
        getOrderBy(val) {
            if(val == 'price_asc') {
                this.sortOrder = 'asc';
                this.filter = 'final_price';
            } else if(val == 'price_desc') {
                this.sortOrder = 'desc';
                this.filter = 'final_price';
            } else {
                this.sortOrder = 'desc';
                this.filter = val;
            }
        },
		submit(){
            window.location.href = `/${this.sitelocale}/search?category_id=${this.category_id}&search_input=${this.search_input}`;
		}
	},
	created() {
		this.nextUrl = this.url;
		this.loadNextPage();
	},
    watch: {
        orderBy: function (val) {
            this.getOrderBy(val);
            this.products = [];
            axios.get(this.url, {
                    params : {'orderBy':this.filter,'direction':this.sortOrder}
                }
            ).then(({data}) => {
                this.products = data.data;
                if(data.links.next != null) {
                    this.loadMore = true;
                    this.nextUrl = data.links.next;
                } else {
                    this.nextUrl = data.links.next;
                    this.loadMore = false;
                }
                this.currentPage = 0;
                this.fetching = false;
            });
        }
    }
}
</script>
